<template>
  <div class="flex items-center" v-if="getMissingKeysCount() > 0 && getLocale() === 'en'">
    <button class="flex items-center block px-4 py-2 text-base text-forecolor" @click="exportMissingKeys()">
      <ArrowDownCircleIcon class="h-6 mr-2" />
      <span class="whitespace-nowrap">{{ $t("Missing translations") }} ({{ getMissingKeysCount() }}) </span>
    </button>
  </div>
</template>
<script setup lang="ts">
import { getLocale } from "@/components/page/menu/locales.js";
import { exportMissingKeys, getMissingKeysCount } from "@/i18n";
import { ArrowDownCircleIcon } from "@heroicons/vue/24/outline";
</script>
